var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer py-2 text-white mx-auto flex-wrap"},[_c('div',[_vm._v(_vm._s(_vm.minutes))]),_vm._v(":\n    "),_c('div',[_vm._v(_vm._s(_vm.seconds))]),_vm._v(":\n    "),_c('div',[_vm._v(_vm._s(_vm.milliseconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }